<template>
  <nav-bar-t-recupera />
  <nav-bar-session />
  <router-view/>
</template>

<script lang="ts">
import NavBarTRecupera from '@/components/Commons/NavBar.vue'
import NavBarSession from '@/components/Commons/NavBarSession.vue'
import * as global from '@/api/global'

import { defineComponent } from 'vue'

export default defineComponent({
    name: "App",
    components: {
        NavBarTRecupera,
        NavBarSession,
    },
    setup(){
      global.getSubDomain()
    }
})

</script>

<style>
#app {
  font-family: book_sirit;/*Avenir, Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
